import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE, noop, USER_CONFIG_STORAGE_KEY, VALIDATIONS } from '@client/shared/constants';
import CallToRecordView from './view';
import Service from '@client/modules/dashboard/service';
import config from '@client/config';
import { debounce, getUserData, validate as validator } from '@client/utils';
import { Alert } from "@client/shared/components";
import Typography from '@mui/material/Typography';

const CALL_FAILURE_STATUS = [
  "Error",
  'Invalid',
  "Busy",
  "NoAnswer",
  "Rejected",
  "GenericError",
  "InternationalDisabled",
  "DestinationBlocked",
  "NotEnoughFunds",
  "NoSuchUser"
];
const defaultState = {
  ringoutId: null,
  callInitiatedTime: null,
  recievingVoicemail: false,
  phoneNumberError: null,
  isPhoneNumberParsed: false,
  isParsingPhoneNumber: false,
  alert: {}
};

let parseTimeout = null;
let timeout = null;
const CallToRecord = ({
  callToRecordVoicemail = null,
  callToRecordVoicemailNumber = null,
  callToRecordVoicemailTitle = "",
  phoneNumberList = [],
  countryList = [],
  handleChange = noop,
  handleJwksResponse = noop,
  voicemailList = [],
}) => {
  const userData = (getUserData() || {}).user || {};
  const [state, setState] = useState(defaultState);

  const makeRingoutCall = async (from) => {
    if (!from) {
      return false;
    }
    const { data } = await Service.getTimestamp();
    const callInitiatedTime = data?.currentTimestamp || new Date().toISOString();
    const response = await Service.makeRingoutCall(from);
    let result = {};
    handleJwksResponse(response, (data) => (result = data || {}));
    if (result.id) {
      setState(prevState => ({
        ...prevState,
        ringoutId: result.id,
        callInitiatedTime,
      }));
    }
    handleChange({ name: "callToRecordVoicemail", value: null }, "custome");
  };

  const showDeleteVoicemailWarning = (success, callInitiatedTime) => {
    setState((prevState) => ({
      ...prevState,
      alert: {
        ...prevState.alert,
        open: true,
        hasCancel: true,
        heading: "Are you sure?",
        positiveLabel: "Continue",
        content: (
          <>
            <Typography variant="body2">
              You have reached the maximum uploads (100) on your account.
              Proceeding will delete the oldest media on the account.
            </Typography>
            {/* <Typography variant="body2" sx={{ mt: 2 }}>
              {voicemailToBeDeleted?.filename}
            </Typography> */}
            <Typography variant="body2" sx={{ mt: 2 }}>
              Please confirm before proceeding.
            </Typography>
          </>
        ),
        preferenceName: "voicemailDeletePreference",
        preference: false,
        onSuccess: () => {
          setState(prevState => ({
            ...prevState,
            alert: {
              ...prevState.alert,
              isLoading: true,
            },
          }));
          postCallHandler(success, callInitiatedTime, true)
        },
      },
    }));
  };

  const postCallHandler = async (success = false, callInitiatedTime, deleteVoicemail = false) => {
    if (success) {
      setState(prevState => ({
        ...prevState,
        recievingVoicemail: true,
      }));

      // let query = `?date_from=${callInitiatedTime}&filename=${callToRecordVoicemailTitle}&delete_voicemail=${deleteVoicemail || !!userData?.voicemailDeletePreference}`;
      // let query = `?date_from=2023-03-06T09:12:51.000Z&filename=${callToRecordVoicemailTitle}&delete_voicemail=${deleteVoicemail || !!userData?.voicemailDeletePreference}`;
      const { data, error } = await Service.uploadVoicemail({
        date_from: callInitiatedTime,
        filename: (callToRecordVoicemailTitle || "").trim(),
        delete_voicemail: deleteVoicemail || !!userData?.voicemailDeletePreference
      });
      let isMaxVoicemail = false;
      if (error) {
        if (Array.isArray(error) && error[0].errorCode === "CMN-423") {
          isMaxVoicemail = true
          showDeleteVoicemailWarning(success, callInitiatedTime);
        } else {
          toast.error(Array.isArray(error) ? error[0].message : error);
        }
      } else {
        handleChange({ name: "callToRecordVoicemail", value: data?.voicemail || {} }, "custome");
      }

      // const response = await Service.getMessageStore(config.voicemailAccountUID, config.voicemailExtensionID, `&messageType=VoiceMail&dateFrom=${callInitiatedTime}`);
      // let messages = [];
      // handleJwksResponse(response, (data) => (messages = data || []));
      //  let voicemail = messages.reduce((acc, message) => {
      //   acc = {
      //     messageId: message.id,
      //     ...(message.attachments.find(attachment => attachment.type === 'AudioRecording') || {})
      //   }
      //    return acc;
      //  }, {});

      //  if (Object.keys(voicemail).length) {
      //   const contentResponse = await Service.getMessageContent(
      //     voicemail.messageId,
      //     voicemail.id,
      //     config.voicemailAccountUID,
      //     config.voicemailExtensionID,
      //   );
      //   let messageContent = {};
      //   handleJwksResponse(contentResponse, (data) => (messageContent = data || {}));
      //   handleChange({ name: "callToRecordVoicemail", value: { ...voicemail, messageContent } }, "custome");
      //  } else {
      //   toast.error("Voicemail not found.");
      //  }
      setState(prevState => ({
        ...prevState,
        recievingVoicemail: false,
        ringoutId: null,
        callInitiatedTime: null,
        alert: isMaxVoicemail ? prevState.alert : {},
      }));
    } else {
      console.log("CALL_FAILED");
    }
  };

  const getRingoutCallStatus = async (callBack = noop) => {
    clearTimeout(timeout);
    const response = await Service.getRingoutCallStatus(state.ringoutId);
    let result = {};
    handleJwksResponse(response, (data) => (result = data || {}));
    const { status = {}} = result;
    const isCallFinished = status?.callStatus === 'Success' && status?.callerStatus === 'Finished';
    const isCallFailedOrNoAnswer = status?.callStatus === 'CannotReach' && (status?.callerStatus === 'Busy' || status?.callerStatus === 'NoAnswer');
    const isCallFailed = CALL_FAILURE_STATUS.includes(status?.callStatus);
    if (isCallFinished || isCallFailedOrNoAnswer || !state.ringoutId || isCallFailed) {
      clearTimeout(timeout);
      setState(prevState => {
        callBack(isCallFinished, prevState.callInitiatedTime);
        return {
          ...prevState, 
          ringoutId: null,
          callInitiatedTime: null,
        }
      });
      if (isCallFailed) {
        toast.error(`Call failed. [${status?.callStatus}]`);
      }
    } else {
      timeout = setTimeout(() => getRingoutCallStatus(callBack), 3 * 1000);
    }
  };

  const parsePhoneNumber = async () => {
    setState(prevState => ({
      ...prevState,
      isParsingPhoneNumber: true,
    }));
    const { data, error } = await Service.parsePhoneNumber({
      originalStrings: [callToRecordVoicemailNumber],
    });
    if (error) {
      toast.error(
        Array.isArray(error)
          ? (error[0] && error[0].message) || DEFAULT_ERROR_MESSAGE
          : error
      );
    }
    const phoneNumbers = data && data.phoneNumbers.map(item => item.e164);
    setState(prevState => ({
      ...prevState,
      isParsingPhoneNumber: false,
      isPhoneNumberParsed: true,
    }));
    handleChange({
      currentTarget: {
        name: 'callToRecordVoicemailNumber',
        value: phoneNumbers && phoneNumbers[0]
      }
    })
  };

  useEffect(() => {
    if (state.ringoutId) {
      getRingoutCallStatus(postCallHandler);
    } else {
      clearTimeout(timeout)
    }
    return () => clearTimeout(timeout);
  }, [state.ringoutId]);

  const cancelCall = () => {
    state.ringoutId && Service.cancelRingout(state.ringoutId);
    setState(prevState => ({
      ...prevState,
      ringoutId: null,
      callInitiatedTime: null,
    }));
  };

  // useEffect(() => {
  //   if (!state.isPhoneNumberParsed && (callToRecordVoicemailNumber || '').length > 9) {
  //     if(parseTimeout) clearTimeout(parseTimeout);
  //     parseTimeout = setTimeout(parsePhoneNumber, 1000);
  //   }
  //   return () => clearTimeout(parseTimeout);
  // }, [callToRecordVoicemailNumber]);

  const patchPreference = async (preference = false) => {
    setState((prevState) => ({
      ...prevState,
      alert: {
        ...prevState.alert,
        preference,
      },
    }));
    const { error } = await Service.setUserPreference(userData.id, {
      [state.alert.preferenceName]: preference,
    });
    if (error) {
      toast.error(
        Array.isArray(error) ? error[0].message : error.message || error
      );
      setState((prevState) => ({
        ...prevState,
        alert: {
          ...prevState.alert,
          preference: !preference,
        },
      }));
    } else {
      localStorage.setItem(
        USER_CONFIG_STORAGE_KEY,
        JSON.stringify({
          user: { ...userData, [state.alert.preferenceName]: preference },
        })
      );
    }
  };

  useEffect(() => {
    if (!((callToRecordVoicemailNumber || "").length < 3 || !!state.phoneNumberError)) {
      parsePhoneNumber();
    }
  }, []);
  return (
    <>
      <CallToRecordView
        callToRecordVoicemailNumber={callToRecordVoicemailNumber}
        callToRecordVoicemailTitle={callToRecordVoicemailTitle}
        phoneNumberError={state.phoneNumberError}
        isPhoneNumberParsed={state.isPhoneNumberParsed}
        isParsingPhoneNumber={state.isParsingPhoneNumber}
        onPhoneNumberChange={(callToRecordVoicemailNumber, phoneNumberError) => {
          const validateResult = validator(callToRecordVoicemailNumber, VALIDATIONS.PHONE, countryList);
          const errorMessage = validateResult?.errorMessage ? validateResult.errorMessage : "";
          setState(prevState => ({
            ...prevState,
            phoneNumberError: phoneNumberError || errorMessage,
            isPhoneNumberParsed: false,
          }));
          handleChange({
            currentTarget: {
              name: 'callToRecordVoicemailNumber',
              value: callToRecordVoicemailNumber
            }
          });
        }}
        phoneNumberList={phoneNumberList}
        countryList={countryList}
        ringoutId={state.ringoutId}
        recievingVoicemail={state.recievingVoicemail}
        makeRingoutCall={makeRingoutCall}
        handleChange={handleChange}
        cancelCall={cancelCall}
        parsePhoneNumber={parsePhoneNumber}
        voicemailList={voicemailList}
      />
      {state.alert.open && (
        <Alert
          open={state.alert.open}
          heading={state.alert.heading}
          content={state.alert.content}
          positiveLabel={state.alert.positiveLabel}
          negativeLabel={state.alert.negativeLabel}
          isLoading={state.alert.isLoading}
          hasCancel={state.alert.hasCancel}
          preferenceName={state.alert.preferenceName}
          preference={state.alert.preference}
          onCancel={() => {
            setState((prevState) => ({
              ...prevState,
              alert: {},
            }));
          }}
          onSuccess={state.alert.onSuccess}
          handlePreference={patchPreference}
        />
      )}
    </>
  );
};

export default CallToRecord;